// JS file for ArticleList

$(() => {
  $('.btn-item.active').prev('.btn-item').show();
})
